export function formatSlotShort(slot) {
  if (!slot) return "—";
  const kind = {
    am: "AM",
    pm: "PM",
    all_day: "All Day",
    custom: slot.start_time && slot.end_time ? `${slot.start_time}–${slot.end_time}` : "Custom",
  }[slot.slot_type] || slot.slot_type;
  return `${slot.date} · ${kind}`;
}

export function formatSlotLabel(slot) {
  if (!slot) return "";
  return {
    am: "AM (morning)",
    pm: "PM (afternoon)",
    all_day: "All Day",
    custom: slot.start_time && slot.end_time ? `Custom · ${slot.start_time}–${slot.end_time}` : "Custom",
  }[slot.slot_type] || slot.slot_type;
}
